import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { PRODUCT_TYPE_MOVIE_REWARDS } from "@config/config";
import { useVenue } from "@queries/useVenue";
import { useVenueSessions } from "@queries/useVenueSessions";
import { ApplicationContext } from "@context/ApplicationContext";
import { SearchContext } from "@context/SearchContext";
import LinkTabs from "@components/LinkTabs";
import VenueInformation from "@components/V3/VenueDetails/VenueInformation";
import VenueSessionSelector from "@components/V3/VenueDetails/VenueSessionSelector";
import VenueTitleCard from "@components/V3/VenueDetails/VenueTitleCard";
import "./style.scss";

const VenueDetailsBase = () => {
    const { id, venue_name } = useParams();
    const { productTypeId } = useContext(ApplicationContext);
    const isMovieRewardsSite = productTypeId === PRODUCT_TYPE_MOVIE_REWARDS;
    const { setVenueName } = useContext(SearchContext);



    useVenue(id, venue_name);
    useVenueSessions(id);
    useEffect(() => {
        if (venue_name) {
            const decodedVenueName = decodeURIComponent(venue_name.replace(/-/g, " ")).replace(/\b\w/g, (c) => c.toUpperCase());
            setVenueName(decodedVenueName);
        }
    }, [venue_name]);

    useVenue(id, venue_name);
    useVenueSessions(id);

    return (
        <>
            <VenueTitleCard />
            <div className="search-details-venue__content">
                <LinkTabs>
                    {isMovieRewardsSite && (
                        <div label="Sessions">
                            <VenueSessionSelector />
                        </div>
                    )}
                    <div label="About">
                        <VenueInformation />
                    </div>
                </LinkTabs>
            </div>
        </>
    );
};
export default VenueDetailsBase;
